const publishing = {
    images: [
        'Publishing Splash'
    ],
    children: {}
}

module.exports = publishing